export default __webpack_public_path__ + "static/media/v02.7b6fd873.jpg";